import { useLazyQuery, useMutation } from "@apollo/client/react";import { useEffect, useState } from "react";

import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import UPDATE_ASIGNACION_PROFESIONAL from "../../../../../data/graphQL/mutations/GestionAsistencial/updateAsignacionProfesional";
import toast from 'react-hot-toast';
import { SelectInput } from "../../../../../components/selectInput/SelectInput";
import { Grid } from "@mui/material";
import { GET_FRECUENCIAS_DISPONIBLES } from '../../../../../data/graphQL/queries/GestionAsistencial/getFrecuenciasDisponibles';
import { adaptFrecuenciaDisponibleArray } from "../../../../../adapters/frecuenciaDisponibleAdapter";
import { DateInput } from "../../../../../components/dateInput/DateInput";
import moment from "moment";
import adaptEvaluacionProfesionalReemplazoGrillaArray from "../../../../../data/graphQL/queries/GestionAsistencial/getEvaluacionProfesionalReemplazoGrilla";

export function TabProfesionalReemplazoUpdateFrecuenciaDialog({
  open,
  handleCloseDialog,
  evaluacionSelected,
  refetchEvaluacionProfesionalReemplazo,
  setEvaluacionProfesionalReemplazo,
  evaluacionProfesionalFrecuencia
}) {
  const [loading, setLoading] = useState(false);
  const [frecuenciaProfesionales, setFrecuenciaProfesionales] = useState([]);
  const [formValues, setFormValues] = useState({
    idFrecuencia: evaluacionProfesionalFrecuencia.data.idFrecuenciaRequerida,
    fechaDesde: evaluacionProfesionalFrecuencia.data.fechaDesde,
    fechaHasta: evaluacionProfesionalFrecuencia.data.fechaHasta
  });

  const handleChange = async (name, value) => {
    if (name == 'fechaHasta') {
      setFormValues((prev) => ({
        ...prev,
        fechaHasta: moment(value, "YYYY-MM-DD", true).isValid() ? moment(value).format("YYYY-MM-DD") : ""
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const [getFrecuenciaProfesionales, { data: dataFrecuenciaProfesionales, loading: frecuenciaProfesionalesLoading }] = useLazyQuery(GET_FRECUENCIAS_DISPONIBLES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataFrecuenciaProfesionales) return;
    setFrecuenciaProfesionales(adaptFrecuenciaDisponibleArray(dataFrecuenciaProfesionales));
  }, [dataFrecuenciaProfesionales]);

  const [updateAsignacionProfesional] = useMutation(UPDATE_ASIGNACION_PROFESIONAL, {
    onCompleted: (dataResp) => {
      setLoading(false);
      if (dataResp.updateAsignacionProfesional.success) {
        toast.success("Asignación actualizada con éxito.");
        refetchEvaluacionProfesionalReemplazo().then(({ data }) => {
          setEvaluacionProfesionalReemplazo(adaptEvaluacionProfesionalReemplazoGrillaArray(data));
        });
        handleCloseDialog();
      } else {
        toast.error(dataResp.updateAsignacionProfesional.error);
      }
    },
    onError: () => {
      toast.error("Error al actualizar la asignación del profesional.");
      setLoading(false);
    }
  });

  const valido = () => {
    if (!formValues.fechaHasta) {
      toast.error("La Fecha Hasta es requerida.");
      return false;
    }

    const fechaHastaNueva = moment(formValues.fechaHasta, "YYYY-MM-DD");
    // no superior a la fecha hasta del contrato
    if (fechaHastaNueva.diff(moment(evaluacionSelected.fechaHasta, "YYYY-MM-DD"), 'days') > 0) {
      toast.error("La Fecha Hasta debe estar dentro del rango del contrato.");
      return false;
    }
    // fecha hasta no menor al día de hoy 
    if (fechaHastaNueva < moment().startOf('day')) {
      toast.error("La Fecha Hasta no puede ser anterior al día de hoy.");
      return false;
    }

    return true;
  };

  const handleAcceptUpdate = () => {
    if (valido()) {
      setLoading(true);
      updateAsignacionProfesional({
        variables: { input: {
            idEvaluacionProfesional: evaluacionProfesionalFrecuencia.data.idEvaluacionProfesional,
            fechaDesde: formValues.fechaDesde,
            fechaHasta: formValues.fechaHasta,
            esReemplazo: 1,
            idEvaluacionProfesionalOriginal: evaluacionProfesionalFrecuencia.data.idEvaluacionProfesionalOriginal
          } }
      });
    }
  };

  useEffect(() => {
    if (!frecuenciaProfesionalesLoading) {
      getFrecuenciaProfesionales({ variables: { idFrecuenciaPlan: evaluacionProfesionalFrecuencia?.data.idFrecuenciaRequeridaOriginal } });
    }
  }, []);

  return (
    <CustomDialog
      title="Actualizar frecuencia reemplazo"
      open={open}
      fullWidth
      maxWidth="sm"
      onCancel={handleCloseDialog}
      onAccept={handleAcceptUpdate}
      cancelText="Cancelar"
      acceptText="Actualizar"
      acceptLoading={loading}
      acceptDisabled={loading}>
      
      <Grid container spacing={3} sx={{ fontSize: '14px' }}>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          <strong>Profesional original:</strong> {evaluacionProfesionalFrecuencia?.data.profesionalOriginal}
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <strong>Fecha:</strong> {moment(evaluacionProfesionalFrecuencia?.data.fechaDesdeOriginal).format("DD/MM/YYYY")} - {moment(evaluacionProfesionalFrecuencia?.data.fechaHastaOriginal).format("DD/MM/YYYY")}
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <strong>Frecuencia:</strong> {evaluacionProfesionalFrecuencia?.data.frecuenciaRequeridaOriginal}
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} sx={{ borderTop: '1pt solid gray', height: '1px' }}>
          &nbsp;
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          <strong>Profesional de reemplazo:</strong> {evaluacionProfesionalFrecuencia?.data.profesional}
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
          <DateInput
            label="Fecha desde"
            name="fechaDesde"
            disabled={true}
            value={formValues?.fechaDesde} />
          
        </Grid>        
        <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
          <DateInput
            label="Fecha hasta"
            name="fechaHasta"
            value={formValues?.fechaHasta}
            onChange={(value) => handleChange('fechaHasta', value)} />
          
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          <SelectInput
            label="Frecuencia"
            name="idFrecuenciaRequerida"
            onChange={(e) => handleChange("idFrecuencia", e.target.value)}
            fullWidth={false}
            sx={{ width: "300px" }}
            options={frecuenciaProfesionales}
            value={formValues?.idFrecuencia || ""}
            margin="none"
            disabled={true} />
                  
        </Grid>
      </Grid>
    </CustomDialog>);

}